var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"rules":"max:255"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-text-field',{attrs:{"label":_vm.name,"outlined":"","error-messages":errors},on:{"change":_vm.emitFieldData},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }